import React from 'react';

import { ErrorBlock } from '@src/components/ErrorBlock';
import { ErrorImage } from '@src/components/ErrorImage';
import { Layout } from 'app/Layout';

import styles from './ServerErrorPage.module.scss';

export const ServerErrorPage = () => (
  <Layout>
    <div className={styles.page}>
      <ErrorImage imageSrc="https://www.sravni.ru/f/images/500.png" alt="500 Ошибка сервера" />
      <ErrorBlock />
    </div>
  </Layout>
);
